import { Navigate, Route, Routes } from 'react-router'
import { ConversationsPageLayout } from 'pages/conversations/layout/conversationsPageLayout'
import { ConversationsPage } from 'pages/conversations/ui/conversationsPage'
import { ConversationRoutes } from 'pages/conversations/route/type'
import { ConversationsPath } from 'pages/conversations/route/conversationsPath'
import { ConversationsTemplateLayout } from 'pages/conversations/layout/ConversationsTemplateLayout/conversationsTemplateLayout'
import { CallsRouter } from 'pages/conversations/pages/calls'
import { SearchRouter } from 'pages/conversations/pages/search/route/searchRouter'

export const ConversationsRouter = () => {
  return (
    <Routes>
      <Route element={<ConversationsPageLayout />}>
        <Route path={`/${ConversationRoutes.search}/*`} element={<SearchRouter />} />

        <Route element={<ConversationsTemplateLayout />}>
          <Route index element={<ConversationsPage />} />
          <Route path={'/:conversationId'} element={<ConversationsPage />} />
          <Route path={`/${ConversationRoutes.calls}`} element={<CallsRouter />} />
          <Route path='*' element={<Navigate to={`/${ConversationsPath.root}`} replace />} />
        </Route>
      </Route>
    </Routes>
  )
}
